<app-loading-spinner *ngIf="displaySpinner" />

<!-- page header -->
<app-page-header title="{{ 'tsd_faq_title' | localize | async }}" (backButtonClick)="navigateBack()" />

<!-- accordion info -->
<div class="faq">
    <app-information-accordion [data]="questionAndAnswerLocalizations" [showIcon]="false" [faqStyles]="true" />
</div>
